// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27MO4","label":"styles_label__3-uMX"};